import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PartnerService } from "../../services/partner.service";
import { ExcelService } from "../../services/excel.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { EmployeeService } from "../../services/employee.service";
//import { data } from 'jquery';

@Component({
  selector: "app-partner-product",
  templateUrl: "./partner-product.component.html",
  styleUrls: ["./partner-product.component.scss"],
})
export class PartnerProductComponent implements OnInit {
  public isPageEditable: boolean = true;
  formSubmitAttempt: boolean = false;
  statusMessage: string = "Loading data please wait...";
  laboratoryTestList: Observable<any>;
  partners: Observable<any>;
  partnersList: Observable<any>;
  productForm: FormGroup;
  productPriceList: Observable<any>;
  selectedPartnerId: string = "";
  selectedProductId: string = "";
  IsFormEdit: boolean = false;
  public isSlide: boolean = false;
  laboratoryProductList: Observable<any>;
  laboratoryTestproductList: Observable<any>;
  public data: any;
  subscriptionCount: any;
  selectedPartner: any;
  subscriptionShow: boolean = true;
  showFamilyMember: boolean = true;
  subscriptionPeriod = 4;
  subscriptionFor = "primary";
  subscriptionList: any = [];
  allpartnerList: Observable<any>;
  familymembers: any = 0;
  subscriptionselected: boolean = false;
  subscriptionPartnerId: any;
  fileToUpload: File = null;
  constructor(
    private _partnerService: PartnerService,
    private _employeeService: EmployeeService,
    private router: Router,
    private fb: FormBuilder,
    private _excelService: ExcelService
  ) {
    this.productForm = fb.group({
      productTypeId: [],
      recordId: [],
      partnerId: [],
      productId: [],
      price: ["", [Validators.required]],
      offerPrice: [],
      currencyType: [],
      unitPrice: ["", [Validators.required]],
      packetPrice: ["", [Validators.required]],
      tradePrice: [],
      maxUsage: [],
      validFrom: [],
      validTill: [],
      description: [],
      familymembers: [],
    });
  }

  ngOnInit() {
    // this.getAllSubscription();
    this.getSubscriptionCount();
    this.getAllSubscriptionData();
    this.getPartnerList();
    this.getProductList();
    this.getProductPriceList();
    console.log("this.partners");
  }

  getSubscriptionCount() {
    this._employeeService.getSubscriptionCount().subscribe((data: any) => {
      if (data.returnCode == 0) {
        this.subscriptionCount = data.length + 1;
      }
    });
  }

  getAllSubscriptionData() {
    console.log("getAllSubscription1");
    this._employeeService
      .getAllSubscriptionList()
      .subscribe((subscribeData: any) => {
        console.log("getAllSubscription ", subscribeData);
        this.subscriptionList = subscribeData.response.subscriptionList;
        // this.subscriptionCount = subscribeData.length + 1;
        for (let index = 0; index < this.subscriptionList.length; index++) {
          if (this.subscriptionList[index].validfrom != null) {
            this.subscriptionList[index].validfrom = this.convertDateToFormat(
              this.subscriptionList[index].validfrom
            );
          }
          if (this.subscriptionList[index].validtill != null) {
            this.subscriptionList[index].validtill = this.convertDateToFormat(
              this.subscriptionList[index].validtill
            );
          }
        }
      });
  }

  convertDateToFormat(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [mnth, day, date.getFullYear()].join("-");
  }

  // getAllSubscription(){
  //   console.log('getAllSubscription1');
  //   this._employeeService.getAllSubscriptionList().subscribe((subscribeData: any)=>{
  //     console.log('getAllSubscription ', subscribeData);
  //     this.subscriptionCount = subscribeData.length + 1;
  //   })
  // }

  getProductList() {
    this._partnerService.getLaboratoryTest().subscribe(
      (employeeData) => {
        if (employeeData == null) {
          this.statusMessage = "Employee Id does not exist..";
        } else {
          this.laboratoryTestList = employeeData.response.productList;
          this.laboratoryTestproductList = this.laboratoryTestList;
        }
        console.log(this.laboratoryTestList);
      },
      (error) => {
        this.statusMessage =
          "Problem with the service. Please try again after sometime";
        console.log(error);
      }
    );
  }

  getPartnerList() {
    this._partnerService.getPartners().subscribe(
      (employeeData) => {
        if (employeeData == null) {
          this.statusMessage = "Employee Id does not exist..";
        } else {
          this.allpartnerList = employeeData.response.partnerList;
          this.partners = employeeData.response.partnerList;
          this.partnersList = this.partners;
          // this.partners = this.partners.filter(t=>((!t.partnerName.includes('Subscription')) || (!t.partnerName.includes('Subscription'))));
          console.log("list got ", this.partners);
          if (!this.selectedPartnerId) {
            this.selectedPartnerId = this.partners
              ? this.partners[0].partnerId
              : null;
          }
        }
        console.log(this.partners);
      },
      (error) => {
        this.statusMessage =
          "Problem with the service. Please try again after sometime";
        console.log(error);
      }
    );
  }

  getProductPriceList() {
    this._partnerService.getPartnerProductsWithPriceDetails().subscribe(
      (employeeData) => {
        if (employeeData == null) {
          this.statusMessage = "Employee Id does not exist..";
        } else {
          if (this.selectedPartnerId) {
            this.productPriceList =
              employeeData.response.laboratoryTestList.filter(
                (t) => t.partnerId == this.selectedPartnerId
              );
          } else {
            this.productPriceList = employeeData.response.laboratoryTestList;
          }
          this.laboratoryProductList = this.productPriceList;
        }
        // console.log('this.productPriceList');
        console.log("full product price", this.productPriceList);
        console.log(
          "full product laboratory price",
          this.laboratoryProductList
        );
      },
      (error) => {
        this.statusMessage =
          "Problem with the service. Please try again after sometime";
        console.log(error);
      }
    );
  }

  selectPeriod(data) {
    if (data == "yearly") {
      this.subscriptionPeriod = 4;
    } else {
      this.subscriptionPeriod = 2;
    }
  }

  selectPrimary(data) {
    if (data == "family") {
      this.showFamilyMember = false;
      this.subscriptionFor = "family";
    } else {
      this.showFamilyMember = true;
      this.subscriptionFor = "primary";
    }
  }

  onSelectionSubsription(data) {
    this.subscriptionselected = true;
    this.subscriptionShow = false;
    this.showFamilyMember = true;
    this.partners = this.allpartnerList.filter(
      (t) => t.partnerType == "Subscription"
    );
    this.selectPartner(this.partners[0].partnerId);
  }

  AddPartnerProduct(record) {
    console.log("addPartnerProduct ", record);
    if (this.subscriptionShow == false) {
      this.formSubmitAttempt = true;
      console.log("this.subscriptionCount ", this.subscriptionCount);
      console.log("test ", record.controls.description.value);
      console.log("test 2 ", this.selectedPartner);
      if (record.controls.familymembers.value) {
        this.familymembers = record.controls.familymembers.value;
      }
      let subscriptionData = {
        token: "",
        familymembers: this.familymembers,
        subscriptiontypeid: this.subscriptionPeriod,
        subscriptionfor: this.subscriptionFor,
        subscriptionid: this.subscriptionCount,
        description: record.controls.description.value,
        subname: this.selectedPartner.partnerName,
        maximumusage: record.controls.maxUsage.value,
        charges: record.controls.price.value,
        partnerid: this.selectedPartnerId,
        // "validfrom": (record.controls.validFrom.value.year) +'-'+(record.controls.validFrom.value.month)+'-'+(record.controls.validFrom.value.day),
        // "validtill":(record.controls.validTill.value.year) +'-'+(record.controls.validTill.value.month)+'-'+(record.controls.validTill.value.day)
      };
      console.log("subscriptionData save", subscriptionData);
      this._employeeService
        .saveSubscription(subscriptionData)
        .subscribe((data) => {
          console.log("success data ", data);
          if (data.returnCode == 0) {
            alert("Subscription Saved Succcessfully");
            this.productForm.reset();
            //  this.getAllSubscription();
            this.getSubscriptionCount();
            this.getAllSubscriptionData();
            this.formSubmitAttempt = false;
            this.subscriptionPeriod = 4;
            this.subscriptionFor = "primary";
            this.familymembers = 0;
            this.getProductPriceList();
          }
        });
    } else {
      this.formSubmitAttempt = true;
      let date = new Date();
      let loginUser = JSON.parse(localStorage.getItem("currentUser"));
      record.value.partnerId = this.selectedPartnerId;
      record.value.productId = this.selectedProductId;
      record.value.token = loginUser.token;
      if (record.invalid) {
        return;
      } else {
        this._partnerService.AddPartnerProduct(record.value).subscribe(
          (data) => {
            if (data.returnCode == 0) {
              alert("records save Sucessfully");
              this.productForm.reset();
              this.formSubmitAttempt = false;
              this.getProductPriceList();
            } else {
              alert(data.returnMsg);
            }
          },
          (error) => {
            alert(error);
            console.log(error);
          }
        );
      }
    }
  }

  deletePartnerProduct(record) {
    let confimationMessage =
      "Are you sure want to Delete " + record.productName;
    if (confirm(confimationMessage)) {
      let loginUser = JSON.parse(localStorage.getItem("currentUser"));
      record.token = loginUser.token;
      this._partnerService.deletePartnerProduct(record).subscribe(
        (data) => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully");
          } else {
            if (data.returnCode == 2) {
            }
          }
          this.getProductPriceList();
        },
        (error) => {
          alert(error);
          console.log(error);
        }
      );
    } else {
    }
  }

  selectPartner(record) {
    console.log("selectedPartner ", record);
    this.getProductPriceList();
    this.selectedPartnerId = record;
    // this.productPriceList = this.productPriceList.filter(t => (t.partnerId == this.selectedPartnerId));
    console.log(" this.productPriceList ", this.productPriceList);
    let partnerData = this.partners.filter(
      (t) => t.partnerId == this.selectedPartnerId
    );
    console.log("partnerData ", partnerData);
    console.log(partnerData);
    //  if((partnerData[0].partnerType == 'Corporate') && partnerData[0].partnerName.includes("Subscription")){
    if (
      partnerData[0].partnerType == "Subscription" &&
      this.subscriptionselected == true
    ) {
      this.selectedPartner = partnerData[0];
      //  this.subscriptionShow = false;
      //  this.showFamilyMember = true;
      console.log("this.selectedPartner ", this.selectedPartner);
      console.log("this.subscriptionShow ", this.subscriptionShow);
    } else {
      console.log("else block");
      this.subscriptionShow = true;
    }
  }

  //method for deleting the subscription.
  deleteSubscription(id) {
    this._employeeService.deleteSubscription(id).subscribe((data) => {
      if (data.returnCode == 0) {
        alert("Subscription Deleted Successfully");
        this.getAllSubscriptionData();
      } else {
        alert("Something went Wrong");
      }
    });
  }

  selectProduct(record) {
    this.selectedProductId = record;
  }

  showUpdate(record) {
    this.IsFormEdit = true;
    this.selectedProductId = record.productId;
    this.selectedPartnerId = record.partnerId;
    this.productForm.controls["recordId"].setValue(record.recordId);
    this.productForm.controls["price"].setValue(record.price);
    this.productForm.controls["unitPrice"].setValue(record.unitPrice);
    this.productForm.controls["packetPrice"].setValue(record.packetPrice);
    this.productForm.controls["tradePrice"].setValue(record.tradePrice);
    this.productForm.controls["offerPrice"].setValue(record.tradePrice);
  }

  updatePartnerProduct(record) {
    this.formSubmitAttempt = true;
    let loginUser = JSON.parse(localStorage.getItem("currentUser"));
    record.value.partnerId = this.selectedPartnerId;
    record.value.productId = this.selectedProductId;
    record.value.token = loginUser.token;
    if (record.invalid) {
      return;
    } else {
      this._partnerService.updatePartnerProduct(record.value).subscribe(
        (data) => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully");
            this.productForm.reset();
            this.formSubmitAttempt = false;
            this.IsFormEdit = false;
            this.getProductPriceList();
          } else {
            alert(data.returnMsg);
          }
        },
        (error) => {
          alert(error);
          console.log(error);
        }
      );
    }
  }

  reset() {
    this.productForm.reset();
    this.IsFormEdit = false;
    this.formSubmitAttempt = false;
  }

  searchProduct(searchValue) {
    if (searchValue) {
      console.log(this.laboratoryProductList);
      this.productPriceList = this.laboratoryProductList;
      this.productPriceList = this.productPriceList.filter(
        (t) =>
          (t.partnerName != null &&
            t.partnerName.toLowerCase().indexOf(searchValue) > -1) ||
          (t.productName != null &&
            t.productName.toLowerCase().indexOf(searchValue) > -1) ||
          (t.price != null && t.price.toLowerCase().indexOf(searchValue) > -1)
      );
    } else {
      this.productPriceList = this.laboratoryProductList;
    }
  }

  onSelectionChange(searchValue) {
    this.subscriptionselected == false;
    this.getPartnerList();
    // this.getProductList();
    //   this.getProductPriceList();
    if (parseInt(searchValue) > 0) {
      console.log("if");

      this.subscriptionShow = true;
      this.laboratoryTestList = this.laboratoryTestproductList;
      this.laboratoryTestList = this.laboratoryTestList.filter(
        (t) => t.productTypeId == searchValue
      );
      this.selectedProductId = this.laboratoryTestList[0].productId;
    } else {
      console.log("else");
      this.laboratoryTestList = this.laboratoryTestproductList;
    }
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    } else {
      this.isSlide = true;
    }
  }

  generatePartnerReport() {
    console.log("generatePartnerReport", this.productPriceList);

    // let data: any = JSON.parse(this.productPriceList);
    let data: any = this.productPriceList;
    function getData() {
      this._partnerService.getPartnerProductsWithPriceDetails().subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          } else {
            // this.productPriceList = employeeData.response.laboratoryTestList
            let data2 = employeeData.response.laboratoryTestList;

            this.laboratoryProductList = this.productPriceList;
          }
          // console.log('this.productPriceList');
          console.log("full product price from generate product report", data);
          console.log(
            "full product laboratory price generate product report",
            this.laboratoryProductList
          );
        },
        (error) => {
          this.statusMessage =
            "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
    }

    this._excelService.exportAsExcelFile(data, "PartnerProductReport");
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  uploadFileToActivity() {
    if (this.fileToUpload) {
      if (
        this.fileToUpload.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        this.fileToUpload.type === "application/vnd.ms-excel"
      ) {
        var loginUser = JSON.parse(localStorage.getItem("currentUser"));
        var form_data = new FormData();
        form_data.append("token", loginUser.token);
        form_data.append("files", this.fileToUpload);
        // admins have no partnerId of their own: send the partner selected on this page
        form_data.append("partnerid", this.selectedPartnerId);
        this._partnerService.productsFileUploadService(form_data).subscribe(
          (data) => {
            if (data["returnCode"] === 0) {
              const updated = data["response"] && data["response"].updated;
              alert("File successfully imported" + (updated ? ": " + updated + " products updated" : ""));
            } else {
              alert(data["returnMsg"] || "Import failed");
            }
            this.ngOnInit();
          },
          (error) => {
            console.log(error);
            alert(this.describeImportError(error.error));
          }
        );
      } else {
        alert("Not an excel file");
      }
    }
  }

  // turns the API's row/recordId details into a message the user can act on
  describeImportError(body: any): string {
    if (!body) {
      return "Import failed";
    }
    let message = body.returnMsg || "Import failed";
    const details = body.response;
    if (details && details.errors && details.errors.length) {
      const lines = details.errors
        .slice(0, 10)
        .map((e) => "Row " + e.row + ": invalid " + e.invalid.join(", "));
      if (details.errors.length > 10) {
        lines.push("... and " + (details.errors.length - 10) + " more rows");
      }
      message += "\n\n" + lines.join("\n");
    } else if (details && details.recordIds && details.recordIds.length) {
      message += "\n\nrecordIds: " + details.recordIds.slice(0, 20).join(", ");
    }
    return message;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/partner-product/partner-product.component.ts